export const ROOT = '/';
export const TEST = ROOT;
export const TEST_QUESTIONS = `${TEST}questions`;
export const TEST_RESULT = `${TEST}result`;
export const TEST_ABOUT = `${TEST}about`;
